import {CacheManager, cacheTypeEnumerate} from '@aofl/cache-manager';
import {uuid} from '@aofl/uuid';
/**
 *
 *
 * @author Arian Khosravi <arian.khosravi@aofl.com>
 */
class TrackerQueue {
  /**
   * Default namespace key for CacheManager storage.
   *
   * @readonly
   */
  static get STORAGE_KEY() {
    return 'tracker-queue';
  }
  /**
   * Creates an instance of TrackerQueue.
   *
   * @param {String} [storageNamespaceKey=TrackerQueue.STORAGE_KEY]
   * @param {String} [storageType=cacheTypeEnumerate.LOCAL]
   */
  constructor(storageNamespaceKey = TrackerQueue.STORAGE_KEY, storageType = cacheTypeEnumerate.LOCAL) {
    this.trackers = {};
    this.storage = new CacheManager(storageNamespaceKey, storageType, 0);
  }
  /**
   * Add a new tracker to the list of trackers
   *
   * @param {String} id
   * @param {Object} trackerObject
   */
  track(id, trackerObject) {
    if (typeof this.trackers[id] !== 'undefined') {
      throw new Error(`Duplicate key exception. A trackObject with ${id} id already exists`);
    }

    this.trackers[id] = trackerObject;
    trackerObject.init();
  }
  /**
   * Removes a previously added tracker.
   *
   * @param {String} id
   * @return {void}
   */
  untrack(id) {
    if (typeof this.trackers[id] === 'undefined') return;
    this.trackers[id].deinit();
    delete this.trackers[id];
  }
  /**
   * Return the array of queued events.
   *
   * @return {Array}
   */
  getQueue() {
    const queueObj = this.storage.getCollection();
    const queue = [];
    for (const key in queueObj) {
      if (!queueObj.hasOwnProperty(key)) continue;
      queue.push(queueObj[key]);
    }

    return queue;
  }
  /**
   * Add a new event to the queue.
   *
   * @param {Object} event
   */
  enqueueEvent(event) {
    this.storage.setItem(uuid(), event);
  }
  /**
   * Attempts to send the queue using the provided callback function. On failure adds the events back to the queue.
   *
   * @param {function} cb
   */
  async sendQueue(cb) {
    const queue = this.getQueue();
    if (!queue.length) return;

    this.storage.clear();
    try {
      await new Promise(() => {
        return cb(queue);
      });
    } catch (e) {
      for (let i = 0; i < queue.length; i++) {
        this.enqueueEvent(queue[i]);
      }
    }
  }
}

export {
  TrackerQueue
};
